__turbopack_context__.v({
  "className": "plus_jakarta_sans_f310c97d-module__F5r1DG__className",
});
